module.exports = __webpack_public_path__ + "img/Twitter.bc2ea4fe.png";